<div class="mat-modal-dialog cancel-modal p-0">
    <h2 mat-dialog-title>
        <mat-icon style="color:red; float: right; cursor: pointer; position: relative; top: 20px;"
            (click)="dialogRef.close()">close</mat-icon>
    </h2>
    <mat-dialog-content>
        <p class="logout" style="text-align: center; font-size: 14px; font-family: poppins; font-weight: 500!important; color: #041D41;">
            Remaining Unallocated Trips {{data}} are pending for submission.</p>
    </mat-dialog-content>
</div>